import api from './axios';

// Get all admissions
export const getAllAdmissions = async (params = {}) => {
  const response = await api.get('/admissions', { params });
  return response.data;
};

// Get admission statistics
export const getAdmissionStats = async () => {
  const response = await api.get('/admissions/stats');
  return response.data;
};

// Get single admission
export const getAdmissionById = async (id) => {
  const response = await api.get(`/admissions/${id}`);
  return response.data;
};

// Submit admission application (public)
export const submitAdmission = async (data) => {
  const response = await api.post('/admissions', data);
  return response.data;
};

// Update admission status
export const updateAdmissionStatus = async (id, status, notes) => {
  const response = await api.patch(`/admissions/${id}/status`, { status, notes });
  return response.data;
};

// Delete admission
export const deleteAdmission = async (id) => {
  const response = await api.delete(`/admissions/${id}`);
  return response.data;
};

const admissionService = {
  getAllAdmissions,
  getAdmissionStats,
  getAdmissionById,
  submitAdmission,
  updateAdmissionStatus,
  deleteAdmission,
};

export default admissionService;
